module.exports = __webpack_public_path__ + "open-sans-italic-light.c7bda75b1d04dd8c00f5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans-italic-light.woff
// module id = 704
// module chunks = 2